/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 18:18:52
 * @FilePath: /unifyxp-v2-store-portal/src/router/PermissionRoute.tsx
 */
import React from 'react';
import { isUserValidOr } from '../tools/getUserInfo';
import { Redirect, Route } from './Components/Route';
import { get } from 'lodash';
import I18nWrapper from 'src/constrains/I18nWrapper';
function PermissionRoute({ component: Component, ...rest }) {
  const { permissionGroup, permissionGroupGenerate, source } = rest;

  // const v = isUserValid({
  //   resourcesGroup: permissionGroup,
  //   roleGroup,
  // });

  //const isLogin = checkIsLogin();
  // console.log('', isLogin, v);
  // if (!isLogin) {
  //   return <Redirect to='/login' />;
  // }
  //console.log('...PermissionRoute', rest);
  const { multipleLanguageProps } = rest;
  return (
    <Route
      {...rest}
      render={(props) => {
        const params = get(props, 'match.params');

        const _permissionGroup =
          permissionGroup || permissionGroupGenerate(params);
        //console.log('_permissionGroup', _permissionGroup);
        const isValid = isUserValidOr({
          resourcesGroup: _permissionGroup,
          source,
        });
        if (isValid) {
          return (
            <I18nWrapper _props={props}>
              <Component
                {...props}
                __salesChannelMultiLanguage={multipleLanguageProps}
              />
            </I18nWrapper>
          );
        } else {
          return (
            <Redirect
              to={{
                pathname: '/permission-forbidden',
                state: { from: props.location?.pathname },
              }}
            />
          );
        }
      }}
    />
  );
}
export default PermissionRoute;
